var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifictionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6386 2.00847C7.59682 2.19884 4.49988 5.67138 4.49988 9.69011V13.3239L3.17469 15.9899C3.17236 15.9948 3.17008 15.9997 3.16785 16.0046C2.63472 17.1383 3.49774 18.4997 4.75086 18.4997H8.99988C8.99988 20.1476 10.352 21.4997 11.9999 21.4997C13.6478 21.4997 14.9999 20.1476 14.9999 18.4997H19.2479C20.5011 18.4997 21.3652 17.1386 20.8319 16.0046C20.8297 15.9997 20.8274 15.9948 20.8251 15.9899L19.4999 13.3239V9.49968C19.4999 5.24658 15.9315 1.80637 11.6386 2.00847ZM11.7089 3.50652C15.1689 3.34363 17.9999 6.08078 17.9999 9.49968V13.4997C17.9998 13.6156 18.0265 13.7299 18.078 13.8337L19.4745 16.6442C19.5643 16.8367 19.4604 16.9997 19.2479 16.9997H4.75086C4.5384 16.9997 4.43534 16.837 4.52527 16.6442V16.6432L5.92176 13.8337C5.97325 13.7299 5.99999 13.6156 5.99988 13.4997V9.69011C5.99988 6.43985 8.48961 3.65815 11.7089 3.50652ZM10.4999 18.4997H13.4999C13.4999 19.3368 12.837 19.9997 11.9999 19.9997C11.1628 19.9997 10.4999 19.3368 10.4999 18.4997Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifictionIcon);
export default __webpack_public_path__ + "static/media/notifiction-icon.cdbc11dfe32a067cf5d3c5c26c2dd954.svg";
export { ForwardRef as ReactComponent };